import Image from "next/image";
import axios from "axios";
import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import mixpanel from "../utils/mixpanel";
import Modal from "@/components/ui/Modal";
import { GetServerSidePropsContext } from "next";
import MarketingEnrollNowForm from "@/components/marketingPages/MarketingPaidForm";

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const id = "cm1w2z9sy18h3pc56rubvuz37";
  const host = context.req?.headers.host;
  const protocol = context.req?.headers["x-forwarded-proto"] || "http";
  const fullDomain = `${protocol}://${host}`;

  try {
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/${id}`,
      {
        headers: {
          "Accept-Encoding": "gzip",
        },
      }
    );

    return {
      props: {
        id: id,
        masterclass: data.data,
        fullDomain: fullDomain,
      },
    };
  } catch (err) {
    return {
      props: {
        masterclass: null,
        id: "",
        fullDomain: "https://www.astrolearn.co/",
      },
    };
  }
}

function lalkitab({
  id,
  masterclass,
  fullDomain,
}: {
  id: string;
  masterclass: any;
  fullDomain: string;
}) {
  const [isEnrollNowFormOpen, setIsEnrollNowFormOpen] = React.useState(false);

  const handleLeadModalOpen = () => {
    setIsEnrollNowFormOpen(true);
    mixpanel.track("enroll_now", {
      type: "paid-product",
      landing_page: "lal-kitab",
      masterclass: masterclass?.title,
      masterClassId: id,
      platform: "astrolearn",
      segment: "single_cta",
    });
  };
  const amount = 49;
  const router = useRouter();
  const source = router.query.source;
  const leadComment = router.query.comment;
  const backComment = source === "google" ? "paidMasterClass" : "paidBootcamp";

  if (typeof window !== "undefined" && !masterclass) {
    window.location.href = "https://astrolearn.co/";
  }
  const slots = masterclass?.slots;
  const activeSlot = slots?.find((slot: any) => {
    return slot.active;
  });

  React.useEffect(() => {
    mixpanel.track("marketing_page", {
      page_location: window.location.href,
      page_referrer: document.referrer,
      masterclass: masterclass?.title,
      type: "paid-product",
      landing_page: "lal-kitab",
      masterclassId: id,
      platform: "astrolearn",
    });
  }, []);

  return (
    <>
      <Head>
        <title>Download Lal Kitab | English PDF | Astrolearn</title>
        <meta
          name="description"
          content="Get the Lal Kitab digital PDF. Discover personalized astrology predictions and remedies with this ancient guide for a better future."
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
             (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-5G6WR26B');
          `,
          }}
        />
      </Head>
      <main className="w-full min-h-screen bg-[url(/marketing/lal-kitab-bg.png)] bg-cover bg-no-repeat grid md:grid-cols-2 md:px-28 items-center justify-center px-6 ">
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-5G6WR26B"
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          ></iframe>
        </noscript>

        <div className="grid grid-cols-4 w-full col-span-2 ">
          <div className="sm:col-span-2 col-span-4 grid font-inter max-md:place-items-center max-md:text-center max-md:gap-2">
            <div className="flex gap-1 items-center mb-2 ">
              <Image
                src="/img/logo.png"
                alt="astrolearn logo"
                width={50}
                height={50}
                className="rounded-md w-[20%] sm:w-auto"
              />
              <p className="font-inter text-2xl">AstroLearn</p>
            </div>
            <h3 className="text-2xl font-bold hidden sm:flex"></h3>
            <h1 className="text-4xl md:text-6xl md:leading-[66px] font-semibold leading-[50px]">
              <p className="text-red-800">LAL KITAB </p>
              Simplified for You{" "}
            </h1>
            <Image
              src="/marketing/lal-kitab-book.png"
              alt="lal kitab picture"
              width={350}
              height={300}
              className="sm:hidden flex max-w-[70%]"
            />
            <p className="text-gray-800 font-semibold">
              Discover quick, easy solutions for life’s biggest problems.
            </p>
            <p className="p-2  rounded-md md:w-2/3 mt-3 min-w-full bg-gradient-to-r from-red-600/20 to-transparent">
              Find remedies for key aspects of life without complications.
            </p>
            <p className="p-2 bg-gradient-to-r from-red-600/20 to-transparent rounded-md md:w-2/3 mt-3 min-w-full">
              Get accurate, time-tested solutions with minimal information.
            </p>
            <p className="p-2 bg-gradient-to-r from-red-600/20 to-transparent rounded-md md:w-2/3 mt-3 min-w-full">
              Ancient wisdom made practical for today’s world.{" "}
            </p>
            <button
              className="bg-red-800 p-4 rounded-md mt-5 text-xl md:text-xl !text-white hover:!text-white hover:scale-105 "
              onClick={handleLeadModalOpen}
            >
              Download Lal Kitab at ₹49/-
            </button>
            <Modal
              isOpen={isEnrollNowFormOpen}
              closeModal={() => setIsEnrollNowFormOpen(false)}
              className="w-full "
            >
              <MarketingEnrollNowForm
                masterClassData={masterclass}
                amount={amount}
                isOpen={isEnrollNowFormOpen}
                activePaidSlotInfo={activeSlot}
                closeModal={() => {
                  setIsEnrollNowFormOpen(false);
                }}
                source={source}
                leadComment={leadComment}
                backComment={backComment}
                fullDomain={fullDomain}
                masterClassId={id}
                token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjQ5LCJpYXQiOjE3NDQ0NDAyMzV9.grKK26hq373iIppM-D6lt7RbEZOPw4wUcrW-F5Bj0Mo"
                redirectLink={`${fullDomain}/${id}/redirect-lal-kitab/thanks-paid`}
              />
            </Modal>
          </div>
          <div className="flex items-center justify-center col-span-2">
            <Image
              src="/marketing/lal-kitab-book.png"
              alt="medicine picture"
              width={350}
              height={300}
              className="hidden sm:flex"
            />
          </div>
        </div>
      </main>
    </>
  );
}

export default lalkitab;
